import NewsEventReducer from "./news-event";

export default {
  newsEvent: NewsEventReducer,
};
